import React from 'react'

import Navbar from './Navbar'
import Sidebar from './Sidebar'
import BottomNavbar from './BottomNavbar'
import { useLocation } from 'react-router-dom'

function NewDashboard() {

  const location = useLocation();
 
  const hideBottomNavbar =
    location.pathname.includes("/checkout/") ||
    location.pathname.includes("/dash/contest-winner") ||
    location.pathname.includes("/dash/contest-question") ||
    location.pathname.includes("dash/contest-result") ||
    location.pathname.includes("/dash/kyc-status")  ||
    location.pathname.includes("/dash/withdrawal") ||
    location.pathname.includes("/dash/transaction-history") ||
    location.pathname.includes("/dash/bank-details") ||
    location.pathname.includes("/dash/security")||
    location.pathname.includes("/dash/dummy-contest") ||
    location.pathname.includes("/dash/quize")  ||
    location.pathname.includes("/dash/wallet") ||
    location.pathname.includes("dash/support")||
    location.pathname.includes("dash/referral") ||
    location.pathname.includes("dash/current-affairs") ||
    location.pathname.includes("dash/state-gk") ||
    location.pathname.includes("dash/leaderBoard") ||
    location.pathname.includes("dash/mock-tests") ||
    location.pathname.includes("dash/mock-test-details") ||
    location.pathname.includes("dash/mock-test-leaderboard") ||
    location.pathname.includes("dash/mock-test-result") ||
    location.pathname.includes("dash/mock-test/") ||
    location.pathname.includes("dash/select-exam") 

  // sirf mobile ke liye hide
  const hideNavbarOnMobile =
    location.pathname.includes("/dash/lectures") ||
    location.pathname.includes("/dash/contest-winner") ||
    location.pathname.includes("/dash/contest-answer-key") ||
    location.pathname.includes("/dash/contest-question") ||
    location.pathname.includes("dash/contest-result") ||
    location.pathname.includes("/dash/kyc-status")  ||
    location.pathname.includes("/dash/withdrawal") ||
    location.pathname.includes("/dash/transaction-history") ||
    location.pathname.includes("/dash/profile") ||
    location.pathname.includes("/dash/bank-details") ||
    location.pathname.includes("/dash/security")  ||
    location.pathname.includes("/checkout/")||
    location.pathname.includes("/dash/contest")  || 
    location.pathname.includes("/dash/plan")  ||
    location.pathname.includes("/dash/quize")  ||
    location.pathname.includes("/dash/wallet") ||
    location.pathname.includes("dash/referral") ||
    location.pathname.includes("dash/current-affairs") ||
    location.pathname.includes("dash/state-gk")||
    // location.pathname.includes("dash/leaderBoard") ||
    // location.pathname.includes("dash/mock-tests") ||
    // location.pathname.includes("dash/mock-test-details") ||
    // location.pathname.includes("dash/mock-test-leaderboard") ||
    location.pathname.includes("/dash/home") 

  return (
    <div>

    <div className="relative z-[40]">
  <Sidebar />
</div>

{/* Desktop => always show navbar */}
{/* Mobile => hide on specific pages */}
<div
  className={`${
     hideNavbarOnMobile ? "hidden lg:block" : "block"
  } relative z-[80]`}
>
  <Navbar />
</div>

      {!hideBottomNavbar && <BottomNavbar />}
    </div>
  )
}

export default NewDashboard
